import { LookupId, socialMediaIconMap } from '@ag-common-lib/public-api';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'socialIcon' })
export class SocialIconPipe implements PipeTransform {
  transform(socialMediaId: LookupId<'AgencySocialMedia'> | LookupId<'SocialMedia'>): string {
    return socialMediaIconMap[socialMediaId] ?? 'link';
  }
}
